"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WeFindYourHiddenHours() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263038" id="we-find-your-hidden-hours" className="relative min-h-[85vh] flex items-center py-20 lg:py-32 overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681550/img/hero_bg_image.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681550/img/hero_bg_image.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681550/img/hero_bg_image.png-wvc-sizes" alt="Premium dark consulting background" className="w-full h-full object-cover object-center brightness-140" loading="eager" />
        {}
        <div className="absolute inset-0 bg-background/90 mix-blend-multiply"></div>
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`max-w-3xl transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-[1.1] mb-6 font-default tracking-tighter bg-gradient-to-b from-white to-zinc-400 bg-clip-text text-transparent">
            We Find Your <br className="hidden lg:block" />
            Hidden Hours.
          </h1>
          
          <p className="text-lg md:text-xl text-zinc-400 mb-10 max-w-[700px] leading-relaxed font-default">
            RecoupTime identifies exactly where AI can reclaim your team's time. 
            Get a personalized efficiency report for your business within 48 hours.
          </p>
          
          <div className="flex flex-col items-start gap-6">
            <Button asChild size="lg" className="bg-[#2D6A4F] text-white hover:bg-[#2D6A4F]/90 font-semibold px-8 py-6 text-base rounded-md transition-all duration-300">
              <Link to="/ContactPage">
                Book a Free Q&A Call
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            
            <p className="text-sm font-mono text-zinc-500 tracking-wider uppercase">
              Olivia AI Agent: Online & Ready to Assist
            </p>
          </div>
        </div>
      </div>
    </section>;
}